module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABOklEQVRYR73YbbHCMBCF4VMHSEECSEAB4ABHIAEHIAEHWAAHzCkJs1PysbtNyh8+ht73mVCy5Q743jYA7uHxEnerEHkNAA4AzgAuAI4L1Bm/hc6WAIb34YXeiBhfA3hz5QngbQnEXxzAIwJ6I5JxRiWgFyIbTwFaI4rxHKAVohovAeYiVPEawItQxzUAK8IU1wK0CHPcAqghXHErIIdwxz2AFIL7+m9v5/ZqGWjTnVB7rJwdPGYcLNa4dwV4HJf9Ge75/Apgp9XL93lWQH7m8m+5RrkVkDrhTnOuJyyA0tnuvp7QAjRfNRdCA9DE47lgRtQAlrgLUQJ44mZEDjAnbkKkAC3iasQU0DKuQkhAj3gVEQE940UEAUvEswj529A9Uo1TUG5W449TrgDHKYeK6WLCGJ5OTv474PIBNTqOoSXiZEMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/close.png
// module id = 304
// module chunks = 191